module.exports = __webpack_public_path__ + "cbe28d5f32d8ce98b0910e4ec8334dd1.pdf";